import { cn } from "@/lib/cn";

type Props<T extends string> = {
  options: readonly T[];
  labels: Record<T, string>;
  selected: T[];
  onToggle: (value: T) => void;
  disabled?: boolean;
};

/** Grid de checkboxes — usado pra services de radiologia e laboratorio. */
export function ServicesCheckboxGroup<T extends string>({
  options,
  labels,
  selected,
  onToggle,
  disabled,
}: Props<T>) {
  return (
    <div className="grid grid-cols-1 gap-2 sm:grid-cols-2">
      {options.map((option) => {
        const checked = selected.includes(option);
        return (
          <label
            key={option}
            className={cn(
              "flex cursor-pointer items-center gap-2.5 rounded-lg border px-3 py-2.5 text-sm transition-colors",
              checked
                ? "border-brand-200 bg-brand-50 text-brand-900"
                : "border-zinc-200 bg-white hover:border-brand-100 hover:bg-brand-50/40",
              disabled && "cursor-not-allowed opacity-50",
            )}
          >
            <input
              type="checkbox"
              checked={checked}
              onChange={() => onToggle(option)}
              disabled={disabled}
              className="h-4 w-4 shrink-0 rounded border-zinc-300 text-brand-600 focus:ring-brand-500"
            />
            <span className="truncate">{labels[option]}</span>
          </label>
        );
      })}
    </div>
  );
}
